export default __webpack_public_path__ + "static/media/Me-documentation.b16e1b49.md";